import React, { useState, useEffect, useRef} from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "../../../assets/dataTable.css";
import { Link, useLocation} from 'react-router-dom';

import { api_crud_route, api_list_route, api_crud_base, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

//import Hosts from '../../Hosts';

    // Gilberto added »
import {
    reqGET, 
    reqDELETE,
	set_language,
	content_language, 

} from '../../../Utils';

import { language } from './Language';

export default function List() {

    const [data, setData] = useState([]);

    const [dataFormations, setDataFormations] = useState([]);

    const data2 = useRef([]);
    const data3 = useRef([]);

    const [refresh, setRefresh] = useState(0);

    const [isloading, setLoading] = useState(true);
    const { pathname } = useLocation();

    const [, set_SIDE_BAR] = useState([])
    const [permissions, set_permissions] = useState({})

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;
            //console.log('PathName', name)
            //console.log('SIDEBAR', sidebar)

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {
                    node.submenu.forEach(subitem => {
                        if (subitem.path === name) {
                            //console.log('NO SUBITEM ', name)
                            set_permissions({ edit: subitem.edit, gest: subitem.gest, view: true, remove: subitem.remove });
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            //console.log(sidebar)
            sidebar.forEach(node => {
                //console.log('Node ', node)
                if(node.path === name && 0) {
                    //console.log('NO ITEM ', node.path)
                    //console.log(node)
                    //console.log('NODE EDIT ' + node.edit)
                    //console.log('NODE REMOVE ' + node.remove)
                    set_permissions({ edit: node.edit, gest: node.gest, view: true, remove: node.remove });
                    //console.log('no true')
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        let fetchApi = () => {


            if('trainee_user' === getTokenInfo().profile) {

                reqGET(`${api_crud_base}/formation/course/search/trainee/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    .then(res => {
                        res.data.forEach(v2 => {

                            data3.current.push(v2)
                            setDataFormations([...data3.current])

                            /*if(v2.content[0]['trainees'] !== undefined) {
                                
                                let x = v2.content[0]['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
                                if(x.length > 0){

                                    v2.content[0].modules.forEach((v3) => {
                                        // console.log('V3', v3)
                
                                        v3.id_module = v3.id
                                        v3.id_formation = v2.id
                                        v3.name_formation = v2.info.name
                                        v3.id = v2.id + '' + v3.id
                
                                        data2.current.push(v3)
                                        setData([...data2.current]); 
                                        //setRefresh(refresh + 1)
                                        
                                    })

                                }
                            }*/

                        })
        
                        UseSidebar().getSidebar(getTokenInfo().profile)
                            .then(v => {
                                //console.log('V ' + v);
                                get_permissions(pathname, v)
                                set_SIDE_BAR(v)
                                setLoading(false)
                            }/* set_SIDE_BAR(v) */);
                    })
                    .catch(error => console.log(error))

            }
            else if('trainer_user' === getTokenInfo().profile) {
                reqGET(`${api_crud_base}/formation/course/search/trainer/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    .then(res => {
                        res.data.forEach(v2 => {

                            data3.current.push(v2)
                            setDataFormations([...data3.current])

                            //console.log('Formações associadas ao formador: ', v2)

                            /*v2.content[0].modules.forEach((v3) => {
                                

                                if(v3['trainer']['id'] === getTokenInfo().id) {

                                    //console.log('Módulos associadas ao formador: ', v3)

                                    v3.id_module = v3.id
                                    v3.id_formation = v2.id
                                    v3.name_formation = v2.info.name
                                    v3.id = v2.id + '' + v3.id
            
                                    data2.current.push(v3)
                                    setData([...data2.current]); 
                                    //setRefresh(refresh + 1)

                                }
                                
                            })*/
                            
                        })
        
                        UseSidebar().getSidebar(getTokenInfo().profile)
                            .then(v => {
                                //console.log('V ' + v);
                                get_permissions(pathname, v)
                                set_SIDE_BAR(v)
                                setLoading(false)
                            }/* set_SIDE_BAR(v) */);
                    })
                    .catch(error => console.log(error))
            }
            else {

                reqGET(api_list_route(getTokenInfo().companycode))
                    .then(res => {
                        res.data.forEach(v2 => {

                            data3.current.push(v2)
                            setDataFormations([...data3.current])

                            /*v2.content[0].modules.forEach((v3) => {
                                //console.log('V3', v3)
        
                                v3.id_module = v3.id
                                v3.id_formation = v2.id
                                v3.name_formation = v2.info.name
                                v3.id = v2.id + '' + v3.id
        
                                data2.current.push(v3)
                                setData([...data2.current]); 
                                //setRefresh(refresh + 1)
                                
                            })*/
                            
                        })
        
                        UseSidebar().getSidebar(getTokenInfo().profile)
                            .then(v => {
                                //console.log('V ' + v);
                                get_permissions(pathname, v)
                                set_SIDE_BAR(v)
                                setLoading(false)
                            }/* set_SIDE_BAR(v) */);
                    })
                    .catch(error => console.log(error))

            }
        }

        fetchApi();
    }, [pathname]);

    let getModules = async(formation_id) => {

        data2.current = []
        setData([]);


        if('trainee_user' === getTokenInfo().profile) {

            await reqGET(`${api_crud_base}/formation/course/search/trainee/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                .then(res => {
                    res.data.forEach(v2 => {

                        if(v2.id === formation_id) {

                            v2.content[0].modules.forEach((v3) => {
                                // console.log('V3', v3)
        
                                v3.id_module = v3.id
                                v3.id_formation = v2.id
                                v3.name_formation = v2.info.name
                                v3.id = v2.id + '' + v3.id
        
                                data2.current.push(v3)
                                setData([...data2.current]); 
                                setRefresh(refresh + 1)
                                
                            })

                        }

                    })
    
                    UseSidebar().getSidebar(getTokenInfo().profile)
                        .then(v => {
                            //console.log('V ' + v);
                            get_permissions(pathname, v)
                            set_SIDE_BAR(v)
                            setLoading(false)
                        }/* set_SIDE_BAR(v) */);
                })
                .catch(error => console.log(error))

        }
        else if('trainer_user' === getTokenInfo().profile) {
            await reqGET(`${api_crud_base}/formation/course/search/trainer/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                .then(res => {
                    res.data.forEach(v2 => {
                        //console.log('Formações associadas ao formador: ', v2)

                        //console.log('ID da formação: ',formation_id)

                        if(v2.id === formation_id){

                            v2.content[0].modules.forEach((v3) => {
                                

                                if(v3['trainer']['id'] === getTokenInfo().id) {

                                    //console.log('Módulos associadas ao formador: ', v3)

                                    v3.id_module = v3.id
                                    v3.id_formation = v2.id
                                    v3.name_formation = v2.info.name
                                    v3.id = v2.id + '' + v3.id
            
                                    data2.current.push(v3)
                                    setData([...data2.current]); 
                                    setRefresh(refresh + 1)

                                }
                                
                            })
                        }
                        
                    })
                })
                .catch(error => console.log(error))
        }
        else {

            await reqGET(api_list_route(getTokenInfo().companycode))
                .then(res => {
                    res.data.forEach(v2 => {

                        if(v2.id === formation_id){
                            v2.content[0].modules.forEach((v3) => {
                                //console.log('V3', v3)
        
                                v3.id_module = v3.id
                                v3.id_formation = v2.id
                                v3.name_formation = v2.info.name
                                v3.id = v2.id + '' + v3.id
        
                                data2.current.push(v3)
                                setData([...data2.current]); 
                                setRefresh(refresh + 1)
                                
                            })
                        }
                        
                    })
                })
                .catch(error => console.log(error))

        }
    }

    const change_accordion = async (e) => {
        //console.log(e);

        let item_id = e.pop() 

        let formation_id = ''

        formation_id = document.getElementById('item-' + item_id).getAttribute('data-formation')

        document.getElementById('a-000').childNodes.forEach((v) => {
            v.getElementsByClassName('accordion__panel')[0].setAttribute('hidden', '')
        })

        await getModules(formation_id)
            .then(() => {
                document.getElementById('item-' + item_id).getElementsByClassName('accordion__panel')[0].removeAttribute('hidden')
            })
    }

    //APAGAR REGISTO
    function apagar(id) {
        if (window.confirm( language[lang].delete_event )) {
            reqDELETE(api_crud_route, { id: id })
                .then(() => {
                    setLoading(true);
                    alert( language[lang].delete_success );
                })
                .then(() => 
                    // fetchApi()
                    console.log('apagar')
                )
                .catch(e => alert( language[lang].delete_error ))
        }
    }

    const columns = [
        {
            name: language[lang].module,
            selector: 'name', 
            cell: row => <div>{row.name}</div>,
            width: '30%',
            sortable: true,
            left: true,
        }, 
        {
            name: language[lang].sessions_number,
            selector: 'sessions_number',
            width: '10%',
            sortable: false,
            left: true,
        },
        {
            name: language[lang].duration,
            selector: 'duration',
            width: '10%',
            sortable: false,
            left: true,
        }, 
        {
            name: language[lang].formation,
            selector: 'name_formation',
            cell: row => <div>{row.name_formation}</div>,
            width: '30%',
            sortable: true,
            left: true,
        },
        {
            name: '',
            left: true,
            export: false,
            print: false,
            width: '20%',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                        <span className="tooltiptext">{language[lang].view}</span>
                    </Link>
                    <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} replace>
                        {/*<img alt={ language[lang].edit } src={'./img/editar.svg'} />*/}
                        <i className="bi bi-pencil"></i>
                        <span className="tooltiptext">{language[lang].edit}</span>
                    </Link>
                    {
                    permissions.gest ?
                        <Link className={permissions.gest ? "button button-gest" : "d-none" } to={{ pathname: endpoints.gest, state: { item: row, operation: 'edit' } }} replace>
                            <i className="bi bi-gear"></i>
                            <span className="tooltiptext">{language[lang].gest}</span>
                        </Link>
                    :
                        null
                    }
                    <button onClick={() => apagar(row['id'])} className={permissions.remove ? "button button-delete d-none" : "d-none" }>
                        <img alt={ language[lang].delete } src={'./img/eliminar.svg'} />
                        <span className="tooltiptext">{language[lang].delete}</span>
                    </button>
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page ,
        rangeSeparatorText: language[lang].table_separator ,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all ,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].search
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{ language[lang].content_list }</h2>
                <p>{ language[lang].content } / { language[lang].content_list }</p>
                {/*console.log('Formações: ', dataFormations)*/}
            </div>

            <div className={`dash-cards-2 body`}>
                <div className="card">
                    <div className="div-table d-none">
                        <div className="table-body">
                            <DataTableExtensions {...tableData}>

                                <DataTable
                                    noDataComponent={ language[lang].no_results }
                                    noHeader
                                    pagination
                                    exportHeaders
                                    paginationComponentOptions={defaultComponentOptions}
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>

                    <div className="div-group">
                        <Accordion
                            id="a-000"
                            allowZeroExpanded
                            allowMultipleExpanded
                            onChange={change_accordion}
                        >
                            
                            {
                                dataFormations.map((v, k) => {

                                    let date_today = new Date().toJSON().split('T')[0];

                                    var date_begin = v.info.date.begin.split('T')[0];
                                    var date_end = v.info.date.end.split('T')[0];

                                    let status = 0

                                    //console.log('Data de fim:', date_end)

                                    if((date_begin !== '' && date_today >= date_begin && (date_today <= date_end || date_end === ''))) 
                                        //curso em desenvolvimento
                                        status = 1

                                    if(date_end !== '' && date_today > date_end)
                                        //curso terminado
                                        status = 2

                                    if(date_today < date_begin)
                                        //curso por iniciar
                                        status = 3
                

                                    return (
                                        <AccordionItem key={k} id={'item-' + k} uuid={k} data-formation={v.id} >
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    <div className="d-inline-flex align-items-center">
                                                        <b className="me-2">{v.info.name}</b>
                                                        <span className={status === 2 ? "badge rounded-pill fw-normal bg-success" : (status === 1 ? "badge rounded-pill fw-normal bg-warning" : "badge rounded-pill fw-normal bg-primary")}>
                                                            {status === 2 ? language[lang].state_ended : (status === 1 ? language[lang].state_open : language[lang].state_to_start)}
                                                        </span>
                                                    </div>
                                                </AccordionItemButton>
                                            </AccordionItemHeading>

                                            <AccordionItemPanel>
                                                <div className="div-table flex-1">
                                                    <div className="table-body">
                                                    <DataTableExtensions {...tableData}>
                                                        <DataTable
                                                            noDataComponent={language[lang].no_results}
                                                            //columns={columns}
                                                            //data={data}
                                                            noHeader
                                                            subHeader
                                                            pagination
                                                            paginationComponentOptions={defaultComponentOptions}
                                                            paginationPerPage={25}
                                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                                        />
                                                        </DataTableExtensions>
                                                    </div>
                                                </div>
                                            </AccordionItemPanel>
                                            
                                        </AccordionItem>
                                    )
                                })    
                            }
					    </Accordion>
                    </div>

                </div>
            </div>
        </main>
    )
}